import { COLOR, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const LIList = styled.li`
  position: relative;
  height: 100%;
`;

export const DivWrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 126px;
  padding: 0 16px;
  font-size: ${FONT_SIZE.M}px;
  padding-top: 4px;
  border-bottom: 4px solid ${({ isActive }) => (isActive ? COLOR.YELLOW900.code : COLOR.GRAY100.code)};
  font-weight: ${({ isActive }) => (isActive ? FONT_WEIGHT.BOLD : FONT_WEIGHT.NORMAL)};

  a {
    height: 100%;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    line-height: 1;
  }
`;
